<template>
  <div>
    <div class="container container-dashboard">
      <div class="title">
        <h2>Settings</h2>
        <p>
          To update your settings, enter a new value in the field you would like
          to update. Hit <b>Submit</b> to process the changes.
        </p>
      </div>
      <div>
        <form @submit.prevent="updateUserInfo">
          <div class="input-field">
            <div class="label">
              <label for="email">Fullname:</label>
            </div>
            <input
              autocomplete="off"
              v-model="fullname"
              type="text"
              id="fullname"
            />
          </div>
          <div class="input-field">
            <div class="label">
              <label for="email">Email:</label>
            </div>
            <input autocomplete="off" v-model="email" type="text" id="email" />
          </div>
          <button class="btn btn-inline" type="submit">Submit</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "../mixins/getUserInfo";
import db from "../firebase/init";
export default {
  name: "Settings",
  mixins: [getUserInfo],
  methods: {
    updateUserInfo() {
      let ref = db.collection("users").doc(this.id);
      ref.update({
        fullname: this.fullname,
        email: this.email,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container-dashboard {
  .title {
    flex-direction: column;
    align-items: flex-start;

    p {
      margin-top: 8px;
      font-size: 14px;
    }
  }
}
form {
  padding: 0 32px;
}
.input-field {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}

.label {
  margin-left: 4px;
}

input {
  font-size: 14px;
  border: none;
  border-bottom: 1px solid #979797;
  margin-top: 0.5rem;
  padding: 0.7rem 4px;
  transition: 500ms ease all;

  &:focus {
    box-shadow: 0 1px 0 0 #6236ff;
    border-color: #6236ff;
  }

  &::placeholder {
    opacity: 0.6;
  }
}

input:focus {
  outline: none;
}

.btn-inline {
  margin-top: 8px;
  display: inline-block;
  width: auto;
  padding: 12px 20px;

  &:hover {
    background-color: #6338ff;
    color: white;
  }
}
</style>
